import type React from 'react';

import { useConnect } from './model';
import * as st from './styles.module.scss';

type Props = {
	id: number;
};

export const ConnectButton: React.FC<Props> = ({ id }) => {
	const { isConnectActive, onConnect } = useConnect(id);

	return (
		<button className={st.connect} disabled={!isConnectActive} onClick={onConnect}>
			Подключиться
		</button>
	);
};
